import React, { Component } from "react";
import { Form, Input, Row, Col, Select, InputNumber, Divider, Button, Spin } from "antd";
import CenterMarkerMap from "../../components/centerMarkerMap/CenterMarkerMap";
import CustomerProductList from "../../components/customerProduct/CustomerProductList";
import { getBranchProducts } from "../../services/branchProduct";
import { withRouter, useParams } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import { checkIsNumber, isEmptyObj } from "../../utils";
import { createCustomer, getCustomer, updateCustomer } from "../../services/customer";
import { getRoute } from "../../services/route";
import CustomerBucketList from "../../components/customerBucket/CustomerBucketList";


const { Option } = Select;

class CustomerForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            customer: {},
            customerProducts: [],
            selectedProductId: undefined,
            branchProducts: [],
            productPrice: undefined,
            productAmount: undefined,
            lat: undefined,
            lng: undefined,
            customerProductRequired: false,
            customerBuckets: [],
            selectedBucketType: undefined,
            bucketNumber: undefined,
            bucketTypes: [
                {name: "ถัง A", value: "TYPE_A"},
                {name: "ถัง B", value: "TYPE_B"},
                {name: "ถัง C", value: "TYPE_C"},
                {name: "ถัง D", value: "TYPE_D"},
                {name: "ถัง F", value: "TYPE_F"}
            ]
        }
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.formRef = React.createRef();
        this.centerMarkerMapRef = React.createRef();
        this.setSelectedProductId = this.setSelectedProductId.bind(this)
        this.onAddProductClicked = this.onAddProductClicked.bind(this)
        this.onDeletedProductClicked = this.onDeletedProductClicked.bind(this)
        this.setLatLng = this.setLatLng.bind(this)
        this.getBranchProducts = this.getBranchProducts.bind(this)
        this.setSelectedBucketType = this.setSelectedBucketType.bind(this)
        this.onAddBucketClicked = this.onAddBucketClicked.bind(this)
        this.onDeletedBucketClicked = this.onDeletedBucketClicked.bind(this)
    }

    async onFormSubmit() {
        const { history, mode, routeId, id } = this.props;
        const { lat, lng, customerProducts, customerBuckets } = this.state
        let values;
        let passed = true;
        try {
            values = await this.formRef.current.validateFields()
        }
        catch (err) {
            values = err.values
            passed = false
        }

        // if (customerProducts.length === 0){
        //     passed = false
        //     this.setState({
        //         customerProductRequired: true
        //     })
        // }
        
        // Construct customer product create objs
        const productSales = []
        for (let i = 0; i < customerProducts.length; i++ ){
            productSales.push({
                "product": customerProducts[i].product.id,
                "sale_price": customerProducts[i].sale_price,
                "sale_amount": customerProducts[i].sale_amount
            })
        }
        values["lat"] = lat
        values["lng"] = lng
        values["product_sales"] = productSales
        values["buckets"] = customerBuckets

        if (passed) {
            if (mode === "CREATE") {
                values["route"] = routeId
                await createCustomer(values)
                // history.push(`/routes/${routeId}`)
                this.formRef.current.resetFields() // Clear all fields
                await this.setState({
                    customerProducts: [],
                    selectedProductId: undefined,
                    productAmount: undefined,
                    productPrice: undefined,
                    customerBuckets: [],
                    selectedBucketType: undefined,
                    bucketNumber: undefined
                }) // Clear all selected fields
                this.centerMarkerMapRef.current.getCurrentPosition() // Reset Map position
                window.scrollTo({ top: 0, left: 0, behavior: 'smooth' }) // Scroll to top
            }
            else if (mode === "EDIT") {
                await updateCustomer(id, values)
                history.push(`/routes/${routeId}`)
            }
        }

    };

    async getData() {
        const { id } = this.props
        const res = await getCustomer(id)
        const customer = res.data.customer
        const customerProducts = res.data.customer.product_sales
        const customerBuckets = res.data.customer.buckets
        this.setState({
            customer,
            customerProducts,
            customerBuckets,
            lat: Number(customer.lat),
            lng: Number(customer.lng),
            dataLoading: false
        })
    }

    async getBranchProducts() {
        const res = await getBranchProducts("", {}, 1, 1000000, "product.id", "ASC")
        const branchProducts = res.data.branch_products.map(bp=>{
            return bp.product
        })
        this.setState({
            branchProducts
        })
    }

    setSelectedProductId(productId) {
        this.setState({
            selectedProductId: productId
        })
    }

    setSelectedBucketType(bucketType) {
        this.setState({
            selectedBucketType: bucketType
        })
    }

    onAddProductClicked() {
        const {selectedProductId, customerProducts, productAmount, productPrice, branchProducts} = this.state
        // Check if exist in array
        let exists = false
        for (let i = 0; i<customerProducts.length; i++){
            if (selectedProductId === customerProducts[i].product.id) {
                exists = true
            }
        }
        // Get product obj from choices with selectedProductId
        let product;
        for (let i = 0; i<branchProducts.length; i++){
            if (selectedProductId === branchProducts[i].id) {
                product = branchProducts[i]
                break;
            }
        }
        if (!exists) {
            customerProducts.push({
                sale_price: productPrice,
                sale_amount: productAmount,
                product
            })
        }
        this.setState({
            customerProducts,
            selectedProductId: undefined,
            productAmount: undefined,
            productPrice: undefined
        })
    }

    onDeletedProductClicked(ind) {
        const { customerProducts } = this.state
        customerProducts.splice(ind, 1);
        this.setState({
            customerProducts
        })
    }

    onAddBucketClicked() {
        const {selectedBucketType, bucketNumber, customerBuckets} = this.state
        customerBuckets.push({
            bucket_type: selectedBucketType,
            bucket_no: bucketNumber
        })
        this.setState({
            customerBuckets,
            selectedBucketType: undefined,
            bucketNumber: undefined
        })
    }

    onDeletedBucketClicked(ind) {
        const { customerBuckets } = this.state
        customerBuckets.splice(ind, 1);
        this.setState({
            customerBuckets
        })
    }

    setLatLng(coord) {
        this.setState({
            lat: coord.lat,
            lng: coord.lng
        })
    }

    componentWillMount() {
        const { mode, routeId } = this.props
        this.setState({
            dataLoading: true
        }, async ()=> {
            if (mode === "EDIT"){
                await this.getData()
            }
            // Get route data to show route name
            const res = await getRoute(routeId)
            const route = res.data.route
            await this.getBranchProducts()
            this.setState({
                routeName: route.name,
                dataLoading: false
            })
        })
        
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { mode } = this.props;
        const { customerProducts, selectedProductId, branchProducts,
            productAmount, productPrice, lat, lng, customerProductRequired, customer, bucketNumber, selectedBucketType, bucketTypes, customerBuckets, routeName} = this.state;

        let renderObj = <div className="center-container"><Spin tip="กำลังโหลดข้อมูล"/></div>;
        if (mode === "CREATE" || !isEmptyObj(customer)){
            renderObj = (
            <div>
                <Divider orientation="center"><span className='name-header'>เพิ่มลูกค้า {routeName}</span></Divider>
                <Form
                ref={this.formRef}
                layout={'vertical'}
                initialValues={customer}
                >
                    <Row gutter={12}>
                        <Col span={24}>
                            <Form.Item
                                hasFeedback
                                label="ชื่อร้าน"
                                name="name"
                                // rules={[
                                //     {
                                //         required: true,
                                //         message: "กรุณาใส่ชื่อร้าน"
                                //     }
                                // ]}
                                >
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={12}>
                        <Col span={24}>
                            <Form.Item
                                hasFeedback
                                label="รายละเอียดเพิ่มเติม"
                                name="description"
                                rules={[]}>
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider orientation="center">ถังลูกค้า</Divider>
                    <Row>
                        <Col xs={24} sm={24} md={10} lg={10} xl={10} xxl={10} style={{marginBottom: 10}}>
                            <Select
                                value={selectedBucketType}
                                style={{ width: '100%' }}
                                placeholder="ขนาดถัง"
                                optionFilterProp="children"
                                onSelect={e => this.setSelectedBucketType(e)}
                            >
                                {bucketTypes.map(bt =>
                                    <Option key={bt.value} value={bt.value}>{bt.name}</Option>
                                )}
                            </Select>
                        </Col>
                        <Col xs={6} sm={6} md={5} lg={5} xl={5} xxl={5} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <span>หมายเลขถัง:</span>
                        </Col>
                        <Col xs={12} sm={12} md={7} lg={7} xl={7} xxl={7}>
                            <Input type="text" value={bucketNumber} onChange={e=>this.setState({bucketNumber: e.target.value})}/>
                        </Col>
                        <Col xs={4} sm={4} md={0} lg={0} xl={0} xxl={0}/>
                        <Col span={2} style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 10}}>
                            <Button
                                style={{ float: 'right' }}
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={this.onAddBucketClicked}
                                disabled={selectedBucketType === undefined || bucketNumber === undefined || bucketNumber === ""}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{backgroundColor: 'white', paddingLeft: 24, paddingRight: 24}}>
                            <CustomerBucketList data={customerBuckets} onDeletedClicked={this.onDeletedBucketClicked}/>
                        </Col>
                    </Row>
                    <Divider orientation="center">สินค้าที่ลง</Divider>
                    {customerProductRequired && <Row>
                        <Col span={24} style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            <span style={{color: 'red'}}>กรุณาเพิ่มสินค้าที่ลง</span>
                        </Col>
                    </Row>}
                    <Row>
                        <Col xs={24} sm={24} md={10} lg={10} xl={10} xxl={10} style={{marginBottom: 10}}>
                            <Select
                                value={selectedProductId}
                                style={{ width: '100%' }}
                                placeholder="สินค้า"
                                optionFilterProp="children"
                                onSelect={e => this.setSelectedProductId(e)}
                            >
                                {branchProducts.map(bp =>
                                    <Option key={bp.id} value={bp.id}>{bp.name}</Option>
                                )}
                            </Select>
                        </Col>
                        <Col xs={4} sm={4} md={2} lg={2} xl={2} xxl={2} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <span>ราคา:</span>
                        </Col>
                        <Col xs={5} sm={5} md={4} lg={4} xl={4} xxl={4}>
                            <InputNumber pattern="\d*" type="number" value={productPrice} onChange={val=>this.setState({productPrice: val})} style={{width: '100%'}}/>
                        </Col>
                        <Col xs={6} sm={6} md={2} lg={2} xl={2} xxl={2} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <span>จำนวน:</span>
                        </Col>
                        <Col xs={5} sm={5} md={4} lg={4} xl={4} xxl={4}>
                            <InputNumber pattern="\d*" type="number" value={productAmount} onChange={val=>this.setState({productAmount: val})} style={{width: '100%'}}/>
                        </Col>
                        <Col xs={1} sm={1} md={0} lg={0} xl={0} xxl={0}/>
                        <Col span={2} style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 10}}>
                            <Button
                                style={{ float: 'right' }}
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={this.onAddProductClicked}
                                disabled={selectedProductId === undefined || !checkIsNumber(productAmount) || !checkIsNumber(productPrice)}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{backgroundColor: 'white', paddingLeft: 24, paddingRight: 24}}>
                            <CustomerProductList data={customerProducts} onDeletedClicked={this.onDeletedProductClicked}/>
                        </Col>
                    </Row>
                    <Divider orientation="center">ตำแหน่ง</Divider>
                    <Row gutter={12}>
                        <Col span={24} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <CenterMarkerMap ref={this.centerMarkerMapRef} defaultZoom={15} center={{lat, lng}} setLatLng={this.setLatLng} findCurrentOnInit={mode === "CREATE"}/>
                        </Col>
                    </Row>
                    <Row gutter={12} style={{marginTop: 15}}>
                        <Col span={24} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Button color="primary" variant="solid" size="large" onClick={this.onFormSubmit}>บันทึก</Button>
                        </Col>
                    </Row>
                </Form>
            </div>
            )
        }
        return renderObj;
    }
}


function pathParamHook(Component) {
    return function WrappedComponent(props) {
      const { id, routeId } = useParams();
      return <Component {...props} id={id} routeId={routeId} />;
    }
}

export default withRouter(pathParamHook(CustomerForm));